import { render, staticRenderFns } from "./RentalDeductions.vue?vue&type=template&id=6e08d8da&scoped=true"
import script from "./RentalDeductions.vue?vue&type=script&lang=js"
export * from "./RentalDeductions.vue?vue&type=script&lang=js"
import style0 from "./RentalDeductions.vue?vue&type=style&index=0&id=6e08d8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e08d8da",
  null
  
)

export default component.exports